import "./footer.css";

import React from "react";
import { Link } from "react-router-dom";

import { CONTACT_DETAILS, CREDIT, FOOTER_LINKS, ROUTES } from "../../data/content";
import { FacebookIcon, InstagramIcon, LinkedInIcon, WhatsAppIcon } from "../general/Icons";

const SOCIALS = [
  { label: "Dikalo Highston on Facebook", link: CONTACT_DETAILS.FACEBOOK_LINK, Icon: FacebookIcon },
  { label: "Dikalo Highston on Instagram", link: CONTACT_DETAILS.INSTAGRAM_LINK, Icon: InstagramIcon },
  { label: "Dikalo Highston on LinkedIn", link: CONTACT_DETAILS.LINKEDIN_LINK, Icon: LinkedInIcon },
];

const Footer = () => {
  return (
    <React.Fragment>
      <footer className={"site-footer"}>
        <div className={"site-footer-inner container"}>
          <nav
            className={"site-footer-links"}
            aria-label={"Footer"}
          >
            {FOOTER_LINKS.map((column, i) => (
              <ul key={i}>
                {column.map((link) => (
                  <li key={link.label}>
                    {link.path ? (
                      <Link to={link.path}>{link.label}</Link>
                    ) : (
                      <a
                        href={link.href}
                        target={"_blank"}
                        rel={"noopener noreferrer"}
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            ))}
          </nav>

          <Link
            to={ROUTES.HOME}
            className={"site-footer-logo"}
            aria-label={"Dikalo Highston - home"}
          >
            <img
              src={"/images/logo.png"}
              alt={""}
              width={371}
              height={198}
              loading={"lazy"}
            />
          </Link>

          <div className={"site-footer-follow"}>
            <a
              href={CONTACT_DETAILS.TOP_REVIEWS_LINK}
              className={"site-footer-badge"}
              target={"_blank"}
              rel={"noopener noreferrer"}
            >
              <img
                src={"/images/badges/venue-in-bryanston.png"}
                alt={"Venue in Bryanston"}
                width={160}
                height={160}
                loading={"lazy"}
              />
            </a>
            <div>
              <p className={"site-footer-follow-title"}>Follow us</p>
              <ul className={"site-footer-socials"}>
                {SOCIALS.map(({ label, link, Icon }) => (
                  <li key={link}>
                    <a
                      href={link}
                      target={"_blank"}
                      rel={"noopener noreferrer"}
                      aria-label={label}
                    >
                      <Icon />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <p className={"site-footer-credit"}>
            © {new Date().getFullYear()} by Dikalo Highston. Proudly created by{" "}
            <a
              href={CREDIT.link}
              target={"_blank"}
              rel={"noopener noreferrer"}
            >
              {CREDIT.label}
            </a>
          </p>
        </div>
      </footer>

      <a
        href={CONTACT_DETAILS.WHATSAPP.link}
        className={"whatsapp-button"}
        target={"_blank"}
        rel={"noopener noreferrer"}
        aria-label={"Chat to us on WhatsApp"}
      >
        <WhatsAppIcon />
      </a>
    </React.Fragment>
  );
};

export default Footer;
